<template>

    <div class="error-page">
        <h2 class="headline text-yellow"> 500</h2>

        <div class="error-content" style="padding:20px 0 0 20px;">
            <h3><i class="fa fa-warning text-yellow"></i> Server error</h3>

            <p>
                Something went wrong while requesting the current page.
                <router-link :to="{name:'dashboard'}">Return to dashboard</router-link>.
            </p>
        </div>
    </div>

</template>

<script>

export default {

    metaInfo: {
        title:'Server error',
    },

    name:'ErrorsServerError',

}

</script>
